import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeFE } from "../const";

export const ECOA_ACCESS_TOKEN_LANG: {
  ECOA_ACCESS_TOKEN_EXPIRED: MvnCodeFE;
} = {
  ECOA_ACCESS_TOKEN_EXPIRED: {
    ko: "만료된 URL로 접근하였습니다. 로그인 페이지로 이동합니다.",
    en: "You have accessed an expired URL. Redirecting to the login page.",
  },
};

MvnCodeInitiate(ECOA_ACCESS_TOKEN_LANG);
